window.caller = function() {
  if ($("*[call]").length){
    $("*[call]").each(function(idx, dom){
      eval($(dom).attr("call"))
    })
  }
}